import Button from "components/button/Button";
import AlertDialog from "components/Dialog";
import { InputField } from "components/InputField";
import { TextareaField } from "components/TextareaField";
import { useFormik } from "formik";
import { getCurrency } from "helper/numberFormat";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";

const EditAccountBillingType = ({
  formik,
  type,
  addNew,
  edit,
  updateFunc,
  createFunc,
  setAddNew,
  setEdit,
  setDisable,
  setDaisableAddNew,
  disable,
}) => {
  const { push } = useHistory();
  const currency = getCurrency();

  const [openDisableAlert, setOpenDisableAlert] = useState(false);

  const preventMinus = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  };
  const handleCloseDialog = () => {
    setOpenDisableAlert(false);
  };
  const handleOnClose = (e) => {
    setOpenDisableAlert(false);
    e.preventDefault();
    formik.setFieldValue("billing_type_name", "");
    formik.setFieldValue("batch_billing_amount", "");
    formik.setFieldValue("statement_message", "");
    push({
      pathname: "/financial-setting/account-billing-types/view",
    });
  };
  const validateCreateFunc = () => {
    if (
      formik.values?.billing_type_name === "" ||
      !formik.values?.billing_type_name.match(
        /^(?![\s-])[\w\s-+]+$/,
        "Enter a valid name"
      )
    ) {
      return toastr.info("Validation", "Please fill the name field");
    }
    if (!formik.values?.ledger_checkbox) {
      if (formik.values?.batch_billing_amount === "") {
        return toastr.info(
          "Validation",
          "Please fill the Bulk Billing Amount field "
        );
      }
    }
    createFunc();

    push({
      pathname: "/financial-setting/account-billing-types/view",
    });
    formik.setFieldValue("billing_type_name", "");
    formik.setFieldValue(
      "batch_billing_amount",
      formik.values?.batch_billing_amount
    );
    formik.setFieldValue("statement_message", "");
  };
  useEffect(() => {
    if (disable === false) {
      setEdit(true);
      setDaisableAddNew(true);
      setDisable(true);
      setAddNew(true);
      push({
        pathname: "/financial-setting/account-billing-types/view",
      });
    }
  }, []);
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  return (
    <div>
      <div className="input-fields addnew-fields ml-10 account-billing-type-edit-form">
        <div className="d-flex justify-content-end p-5 mt-5">
          <Button
            onClick={() => setOpenDisableAlert(true)}
            variant="primary-outline"
            size="md"
            style={{ minWidth: 80 }}
          >
            Cancel
          </Button>
          <Button
            className="ml-5"
            onClick={
              edit === true
                ? updateFunc
                : addNew === true
                  ? validateCreateFunc
                  : ""
            }
            variant="primary"
            size="md"
            style={{ minWidth: 80 }}
          >
            Save
          </Button>
          <AlertDialog
            open={openDisableAlert}
            handleClose={handleCloseDialog}
            onDecline={() => {
              setOpenDisableAlert(false);
            }}
            onAccept={handleOnClose}
            title={"Are you sure?"}
            description={"Do you want to discard the changes you made?"}
          />
        </div>
        <div className="col-sm-4 billing-amount-details">
          <div className="position-relative billing-input-field pb-2">
            <InputField
              type="text"
              {...{
                formik,
                title: "",
                name: `billing_type_name`,
                placeholder: "Billing Type Name",
              }}
              value={formik.values?.billing_type_name}
              style={{
                backgroundColor: "#F3F6F9",
              }}
            />{" "}
          </div>
        </div>
        <div className="col-sm-4 billing-amount-details">
          <div className="position-relative billing-input-field pb-2">
            <InputField
              type="number"
              {...{
                formik,
                title: "Bulk Billing Amount",
                name: `batch_billing_amount`,
                placeholder: addNew === true ? "Amount" : "99.00",
              }}
              onKeyDown={(e) => preventArrows(e)}
              // onKeyDown={preventMinus}
              style={{ backgroundColor: "#F3F6F9" }}
              value={formik.values?.batch_billing_amount}
              handleChange={(e) => {
                formik.setFieldValue(
                  `batch_billing_amount`,
                  e.target.value.match(regex)[0]
                );
              }}
            />
            <span>
              {currency}
            </span>
          </div>
        </div>
        <div className="col-sm-9 mt-3 statement-field">
          <TextareaField
            {...{
              formik,
              title: "Statement Message",
              name: "statement_message",
              placeholder:
                addNew === true ? "Message text" : "1st year membership",
            }}
            value={formik.values?.statement_message}
            style={{ backgroundColor: "#F3F6F9", resize: "none" }}
          />
        </div>
      </div>
    </div>
  );
};

export default EditAccountBillingType;
